export enum MensagensCO2Enum {
    TITULO_MODAL_CONDENSACAO = 'Atenção!',
    MENSAGEM_MODAL_CONDENSACAO = 'Para evitar condensação na cobertura do silo/armazém e prejudicar a qualidade do grão armazenado, é necessário que todos os respiros sejam limpos periodicamente.',
}
